import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ApiViewDocumentsConstants } from "./unsecure-view-document.service.constants";
let UnsecureViewDocumentsService = class UnsecureViewDocumentsService {
    http;
    constructor(http) {
        this.http = http;
    }
    getViewDocumentsObservable(params) {
        const url = `${ApiViewDocumentsConstants.URL}/${ApiViewDocumentsConstants.FUNCTION_GET_PUBLIC_DOCUMENTS}`;
        return this.http.get(url, { params }).pipe(map(requestComment => {
            return requestComment;
        }));
    }
    getAttachmentContentObservable(attachmentId) {
        return this.http.get(`${ApiViewDocumentsConstants.URL}/${attachmentId}/${ApiViewDocumentsConstants.FUNCTION_GET_ATTACHMENT_CONTENT}`, { responseType: "blob" });
    }
    updateDocumentRequestStatus(request) {
        const url = `${ApiViewDocumentsConstants.URL}/${ApiViewDocumentsConstants.FUNCTION_UPDATE_DOCUMENT_REQUEST_STATUS}`;
        return this.http.post(`${ApiViewDocumentsConstants.URL}/${ApiViewDocumentsConstants.FUNCTION_UPDATE_DOCUMENT_REQUEST_STATUS}`, request);
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
UnsecureViewDocumentsService = __decorate([
    Injectable({
        providedIn: 'root'
    })
], UnsecureViewDocumentsService);
export { UnsecureViewDocumentsService };
